import { useState, useEffect } from "react";
import { authHeaders }          from "../lib/auth";
import { docKeyToOnboardingKey, allDocsSigned } from "../lib/signnow";
import { MOCK_USER }            from "../data/mockData";
import { BYPASS_LOCK }          from "../utils/profileHelpers";

/**
 * useProfile
 *
 * Fetches the current user from /api/me on mount (falls back to MOCK_USER).
 * Exposes helpers for updating profile fields and marking documents signed.
 *
 * Returns:
 *   user         – current user object
 *   setUser      – raw setter (for profile edits)
 *   docsLocked   – boolean: true when training/goals should be gated
 *   handleDocSigned(docKey) – marks a doc as signed in local state
 */
export function useProfile() {
  const [user, setUser] = useState(MOCK_USER);

  useEffect(() => {
    fetch("/api/me", { headers: authHeaders() })
      .then(r => r.json())
      .then(d => { if (!d.error) setUser(d); })
      .catch(() => {/* silently fall back to MOCK_USER */});
  }, []);

  function handleDocSigned(docKey) {
    const onboardingKey = docKeyToOnboardingKey(docKey);
    if (!onboardingKey) return;
    setUser(u => ({
      ...u,
      onboarding: { ...u.onboarding, [onboardingKey]: true },
    }));
  }

  // BYPASS_LOCK = true skips the doc-signing gate for testing
  const docsLocked = BYPASS_LOCK ? false : !allDocsSigned(user?.onboarding);

  return { user, setUser, docsLocked, handleDocSigned };
}